import { GridColDef, GridColumnGroupingModel } from '@mui/x-data-grid-pro';

interface getQuantifyTableColumnGroupingModelParams {
  dynamicColumns: GridColDef[];
  groupId: string;
}

export function getQuantifyTableColumnGroupingModel({
  dynamicColumns,
  groupId,
}: getQuantifyTableColumnGroupingModelParams): GridColumnGroupingModel {
  if (!dynamicColumns.length) {
    return [];
  }

  return [
    {
      groupId,
      description: '',
      children: dynamicColumns.map(({ field }) => ({ field })),
      headerAlign: 'center',
    },
  ];
}
